import React from 'react';
import CourseList from '../components/Courses/CourseList';
import { Link, useNavigate } from 'react-router-dom';

const Courses = () => {
    const navigate = useNavigate();

    const openRegistrationForm = (e) => {
        e.preventDefault();
        console.log('Abrindo formulário de inscrição personalizado...');
        navigate('/inscricao');
    };

    return (
        <div className="flex flex-col min-h-screen">
            {/* Logo Section - Centralizada */}
            <section className="pt-20 pb-6 bg-gradient-to-br from-gray-50 to-orange-50">
                <div className="container mx-auto px-4">
                    <div className="flex justify-center items-center">
                        <a 
                            href="https://www.instagram.com/ecoadventuresm/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="transform hover:scale-105 transition-transform duration-300"
                        >
                            <img 
                                src="/image.png" 
                                alt="EcoAdventure Logo" 
                                className="h-16 md:h-20 lg:h-24 transition-all duration-300 cursor-pointer"
                            />
                        </a>
                    </div>
                </div>
            </section>
            
            {/* Hero Section - Estilo Apple */}
            <section className="pb-16 bg-gradient-to-br from-gray-50 to-orange-50 overflow-hidden">
                <div className="container mx-auto px-4">
                    <div className="flex flex-col items-center text-center mb-16">
                        <span className="text-orange-600 text-sm font-bold tracking-wide uppercase mb-6 bg-orange-100 px-4 py-2 rounded-full">Catálogo de Cursos</span>
                        <h1 className="apple-headline text-gray-900 mb-6 leading-tight">
                            Formação e qualificação<br/>de excelência para socorristas
                        </h1>
                        <p className="apple-subheadline mx-auto mb-8">
                            Conheça nossa variedade de cursos especializados para profissionais que desejam atuar em situações de resgate e emergência.
                        </p>
                        <button 
                            onClick={openRegistrationForm}
                            className="btn-primary text-center"
                        >
                            Inscreva-se Agora
                        </button>
                    </div>
                </div>
            </section>

            {/* Courses Section - Estilo Apple */}
            <section className="py-16 bg-white">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-12">
                        <span className="text-orange-600 text-sm font-bold tracking-wide uppercase mb-3 block bg-orange-100 px-4 py-2 rounded-full inline-block">Nossos Programas</span>
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Cursos Disponíveis</h2>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            Escolha entre nossos cursos especializados para iniciar ou aprimorar sua carreira como socorrista.
                        </p>
                    </div>
                    
                    {/* Aqui usamos apenas o componente CourseList sem props, ele obtém cursos do contexto */}
                    <CourseList />
                </div>
            </section>

            {/* Call to Action - Estilo Apple */}
            <section className="apple-gradient py-24 text-white">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="text-3xl md:text-4xl font-semibold mb-6">Pronto para iniciar sua formação?</h2>
                    <p className="text-xl opacity-90 max-w-2xl mx-auto mb-10">
                        Inscreva-se em nossos cursos hoje mesmo e dê o próximo passo em sua carreira como socorrista profissional.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <button 
                            onClick={openRegistrationForm}
                            className="bg-white text-blue-600 py-4 px-8 rounded-full text-lg font-medium hover:bg-opacity-90 transition-colors"
                        >
                            Inscreva-se Agora
                        </button>
                        <Link to="/" className="border border-white text-white py-4 px-8 rounded-full text-lg font-medium hover:bg-white hover:bg-opacity-10 transition-colors">
                            Voltar para a Home
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Courses;